<template>
	<div class="videoWarp">
		<div class="imgtox">
			<p class="title" style="margin-bottom:20px;">
				<span>带你看展</span>
				<em></em>
			</p>
			<div class="videobox">
				<video src="https://media.artron.net/trad/mp4/201907/03fc14990d974684dde443ac0c9486d3.mp4" controls="controls" poster="../static/v1.png"></video>
			</div>
		</div>
		<div class="imgtox">
			<p class="title" style="margin-bottom:20px;">
				<span>展览开幕式直播回顾</span>
				<em style="width:2rem"></em>
			</p>
			<div class="videobox">
				<video src="https://media.artron.net/trad/mp4/201906/e064f2ab9802ca633eeb78c6575418ae.mp4" controls="controls" poster="../static/8.png"></video>
			</div>
		</div> 
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	export default {
		methods:{
			goback(){
				this.$router.go(-1)
			}
		}
	}
</script>
<style scoped>
	.goback{
		width: 0.62rem;
		height: 0.62rem;
		background:url(../static/g.png);
		background-size: 100% 100%;
		border-radius:100%;
		position: fixed;
		right: 20px;
		top: 60%;
	}
	.imgtox .title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
	}
	.imgtox .title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.imgtox .title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.videobox{
		width: 90%;
		margin: 0 auto;
	}
	.videobox video{
		width: 100%;
		margin-top: .3rem;
		border-radius:10px;
	}
</style>